import React from 'react';
import { Box, Button, Chip, IconButton, Tooltip } from '@mui/material';
import InsightsIcon from '@mui/icons-material/Insights';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function PreparationInsightStrip({ t, philosophyOpen, onTogglePhilosophy }) {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1,
      flexWrap: 'wrap',
      py: 0.35,
      borderBottom: '1px solid #eef2f7',
    }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.55, alignItems: 'center', minWidth: 0 }}>
        <Chip size="small" icon={<InsightsIcon sx={{ color: '#0ea5e9 !important', fontSize: '14px !important' }} />} label={t('preparation.chips.backtest')} sx={{ height: 22, fontSize: '0.66rem', bgcolor: '#eff6ff', color: '#0369a1', fontWeight: 700, border: '1px solid #bfdbfe' }} />
        <Chip size="small" label={t('preparation.chips.avg20d')} sx={{ height: 22, fontSize: '0.66rem', bgcolor: '#dcfce7', color: '#166534', fontWeight: 700 }} />
        <Chip size="small" label={t('preparation.chips.alpha')} sx={{ height: 22, fontSize: '0.66rem', bgcolor: '#e0e7ff', color: '#3730a3', fontWeight: 700 }} />
        <Chip size="small" label={t('preparation.chips.monotonic')} sx={{ height: 22, fontSize: '0.66rem', bgcolor: '#f3e8ff', color: '#7e22ce', fontWeight: 700 }} />
        <Tooltip title={t('preparation.thesisDesc')} arrow>
          <IconButton size="small" sx={{ color: '#94a3b8', p: 0.35 }}>
            <InfoOutlinedIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Button
        size="small"
        onClick={onTogglePhilosophy}
        endIcon={<ExpandMoreIcon sx={{ fontSize: 18, transform: philosophyOpen ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }} />}
        sx={{ textTransform: 'none', fontSize: '0.68rem', fontWeight: 700, color: '#64748b', minWidth: 0, py: 0.25 }}
      >
        {philosophyOpen ? t('preparation.philosophy.hide') : t('preparation.philosophy.show')}
      </Button>
    </Box>
  );
}
